import type { FrontendWidget } from '../types';
import { OfferLocationsListComponent } from './OfferLocationsListComponent';
import type {
  OfferLocationsListConfig,
  OfferLocationsListResolved,
} from './types';

export const offerLocationsListWidget: FrontendWidget<
  OfferLocationsListConfig,
  OfferLocationsListResolved
> = {
  componentType: 'widgets.offer-locations-list',
  displayName: 'Offer Locations List',
  ComponentA: OfferLocationsListComponent,
  // Inline widget (30.03.05): the rows come from the render context, which
  // `/angebote/{slug}/` fills — `POST /render-page` never sees the offer.
  resolveSync: (config) => config,
};
